<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <h1 class="title is-4">Accounts</h1>
      <div class="mt-3">
        <div v-if="waiting">
          <span class="icon is-medium is-size-4">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </div>
        <div v-else>
          <table class="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th>#</th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('id')">Id</span>
                  <span class="icon" v-if="sortOption.field == 'id'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('nsId')">NS id</span>
                  <span class="icon" v-if="sortOption.field == 'nsId'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('accountNumber')">Account number</span>
                  <span class="icon" v-if="sortOption.field == 'accountNumber'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('name')">Name</span>
                  <span class="icon" v-if="sortOption.field == 'name'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('type')">Type</span>
                  <span class="icon" v-if="sortOption.field == 'type'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('currency')">Currency</span>
                  <span class="icon" v-if="sortOption.field == 'currency'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('description')">Description</span>
                  <span class="icon" v-if="sortOption.field == 'description'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="action-column">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in showingAccounts" :key="'account-' + v.id" class="vendor-row" :class="{'has-background-white-ter': v.id == lastEditing}" :id="'account-'+v.id">
                <td>{{i+1}}</td>
                <td>{{v.id}}</td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.nsId}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.nsId">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.accountNumber}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.accountNumber">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.name}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.name">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.type}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.type">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.currency}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.currency">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.description}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.description">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="action-column">
                  <span class="vendor-actions">
                    <a @click="setEditingItem(v)">
                      <span class="icon">
                        <i class="fas fa-edit"></i>
                      </span>
                    </a>
                    <a class="has-text-danger ml-3" @click="deleteAccount(v)">
                      <span class="icon">
                        <i class="fas fa-trash"></i>
                      </span>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <button class="button" @click="addAccount">
                    <span class="icon">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span>New</span>
                  </button>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from 'dateformat'

export default {
  name: 'Accounts',
  data () {
    return {
      error: '',
      waiting: false,
      accounts: [],
      sortOption: {
        field: 'id',
        asc: true,
      },
      editingItem: null,
      lastEditing: null,
      updating: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    showingAccounts () {
      var sort = this.sortOption
      var sortedAccounts = [...this.accounts]
      sortedAccounts.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (sort.field == 'id') {
          return sort.asc ? va - vb : vb - va
        }
        if (!va && !vb){
          return 0
        }
        if(!va) {
          return sort.asc ? 1 : -1
        }
        if (!vb) {
          return sort.asc ? -1 : 1
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedAccounts
    },
  },
  methods: {
    getAccounts () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-accounts/').then(resp => {
        var accounts = resp.body
        this.accounts = accounts
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    changeSortOption (field) {
      if (this.sortOption.field == field) {
        this.sortOption.asc = !this.sortOption.asc
        return
      }
      this.sortOption.field = field
    },
    setEditingItem (account) {
      if (this.editingItem && this.editingItem.id == account.id) {
        this.editingItem = null
        this.lastEditing = null
        return
      }
      this.editingItem = {...account}
      this.lastEditing = account.id
    },
    updateEditingItem () {
      this.updating = true
      this.$http.post(this.server + '/myapp/update-account/', this.editingItem).then(resp => {
        this.updating = false
        this.updateAccountFromUpdating()
        this.scrollToAccount(this.editingItem.id)
        this.editingItem = null
      }, err => {
        this.error = err.body
        this.updating = false
      })
    },
    deleteAccount (account) {
      var confirm = {
        title: 'Delete account',
        message: 'Are you sure to remove this account: ' + JSON.stringify(account) + '?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.deleteAccountConfirmed,
          args: [account]
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    deleteAccountConfirmed (account) {
      this.$http.post(this.server + '/myapp/delete-account/', {id: account.id}).then(resp => {
        var index = this.accounts.findIndex(v => v.id == account.id)
        this.accounts.splice(index, 1)
      }, err => {
        this.error = err.body
      })
    },
    addAccount () {
      var confirm = {
        title: 'Add account',
        message: 'Are you sure to add an empty account?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.addAccountConfirmed,
          args: []
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    addAccountConfirmed () {
      var message = {nsId: '', name: '', accountNumber: '', description: '', type: '', currency: ''}
      this.$http.post(this.server + '/myapp/create-account/', message).then(resp => {
        var account = resp.body
        this.accounts.push(account)
        this.scrollToAccount(account.id)
      }, err => {
        this.error = err.body
      })
    },
    updateAccountFromUpdating() {
      var index = this.accounts.findIndex(v => v.id == this.editingItem.id)
      this.accounts.splice(index, 1, this.editingItem)
    },
    scrollToAccount(accountId) {
      setTimeout(() => {
        const targetElement = document.getElementById("account-" + accountId);
        if (targetElement) {
          targetElement.scrollIntoView({ 
            behavior: "smooth", // "auto" for instant jump
            block: "start",     // Vertically aligns to "start", "center", "end", or "nearest"
            inline: "nearest"   // Horizontally aligns the element
          });
        }
      }, 1000)
    },
  },
  mounted () {
    this.$nextTick(function () {
      this.getAccounts()
    })
  },
}
</script>

<style scoped lang="scss">
.vendor-row .vendor-actions {
  display: none;
}

.vendor-row:hover .vendor-actions {
  display: block;
}

.action-column {
  width: 100px;
}

.data-column {
  min-width: 150px;
}
</style>
